import React from 'react';
import { Box, CardMedia, Typography } from '@mui/material';

type TicketCardHeaderProps = {
  imageUrl: string;
  gameName: string;
  startDateLabel: string;
  endDateLabel: string;
  pricePoint: number;
  packRetailValue: number;
  plu: string | number;
  ticketsSold: number;
  ticketsPerPack: number;
  activeDateLabel: string;
};

const TicketCardHeader: React.FC<TicketCardHeaderProps> = React.memo(({
  imageUrl,
  gameName,
  startDateLabel,
  endDateLabel,
  pricePoint,
  packRetailValue,
  plu,
  ticketsSold,
  ticketsPerPack,
  activeDateLabel,
}) => {
  return (
    <Box className="top">
      <CardMedia
        component="img"
        height="120px"
        image={imageUrl}
        alt={gameName}
        className="media"
      />

      <Box className="info">
        <Box className="header-row">
          <Box>
            <Typography variant="body1" className="title">
              {gameName}
            </Typography>
            <Typography variant="body2" className="subtitle">
              {startDateLabel} - {endDateLabel}
            </Typography>
          </Box>

          <Box className="price">
            <Typography variant="body2" className="metaValue">
              ${pricePoint}
            </Typography>
            <Typography variant="body2" className="metaValue">
              ${packRetailValue}
            </Typography>
          </Box>
        </Box>
        <hr />

        <Box className="meta">
          <Box className="metaRow">
            <Typography variant="body2" className="metaLabel">
              PLU:
            </Typography>{' '}
            <Typography variant="body2" className="metaValue">
              {plu}
            </Typography>
          </Box>
          <Box className="metaRow">
            <Typography variant="body2" className="metaLabel">
              Tickets Sold:
            </Typography>{' '}
            <Typography variant="body2" className="metaValue">
              {ticketsSold} / {ticketsPerPack}
            </Typography>
          </Box>
          <Box className="metaRow">
            <Typography variant="body2" className="metaLabel">
              Active:
            </Typography>{' '}
            <Typography variant="body2" className="metaValue">
              {activeDateLabel}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

TicketCardHeader.displayName = 'TicketCardHeader';

export default TicketCardHeader;
